import { Typography } from './Typography';
import { Button } from './Button';
import { company, clients } from '../content/site';
import styles from './AboutSection.module.css';
export function AboutSection() {
  return (
    <section className={styles.section}>
      <div className={styles.image}>
        <img
          src="/images/audit-architecture.webp"
          alt="Архитектурная иллюстрация: стеклянные фасады в синем свете"
          loading="lazy"
        />
        <div className={styles.imageCaption}>
          <Typography variant="metric" tone="inverse">
            2022
          </Typography>
          <Typography variant="small" tone="inverse">
            Год регистрации компании
          </Typography>
        </div>
      </div>
      <div className={styles.copy}>
        <Typography variant="eyebrow" tone="muted">
          Астана · Казахстан
        </Typography>
        <Typography as="h2" variant="heading">
          Независимый взгляд на ваш бизнес
        </Typography>
        <Typography tone="muted">{`ТОО «Audit Vector». ${company.description}`}</Typography>
        <Typography tone="muted">
          Работаем с крупными объёмами запасов, распределёнными складами и сложной производственной
          инфраструктурой. От планирования проверки до подготовки итогового отчёта.
        </Typography>
        <Button href="/documents/audit-vector-presentation.pdf" download icon="download">
          Презентация компании
        </Button>
      </div>
      <div className={styles.clients}>
        <Typography as="h2" variant="heading">
          Наши клиенты
        </Typography>
        <div className="grid grid-cols-1 md:grid-cols-2">
          {clients.map((x) => (
            <div className={styles.client} key={x.name}>
              <Typography as="h3" variant="subheading">
                {x.name}
              </Typography>
              <Typography variant="small" tone="muted">
                {x.ind}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
